import React from "react";

import { SignInTemplate } from "../../templates";

export const SignInPage: React.FC = () => {
  return (
    <SignInTemplate />
  )
};
